import { get } from 'lodash';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router';

import CasinoGameList from '@swf/components/CasinoGameList/CasinoGameList';
import BackButton from '@swf/components/StarsModal/components/BackButton';
import CloseButton, { Variant } from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import Translation from '@swf/components/Translation/Translation';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { DefaultModel } from '@swf/core/models/widget';
import type { Dispatch } from '@swf/core/store';
import type { CasinoRace } from '@swf/core/types/CasinoRaces';
import { CasinoIcon } from '@swf/generated/types/common/Casino';

import { TXTACL_Pick_Your_Game } from './CasinoRaceGameSelector.messages.json';
import styles from './CasinoRaceGameSelector.scss';

const CasinoRaceGameSelector: React.FC<
  RouteComponentProps<object, object, { widgetId: string; path: string }>
> = ({
  location: {
    state: { widgetId, path }
  }
}) => {
  const { modal } = useDispatch<Dispatch>();
  const { widgetSelect } = useWidget<void, DefaultModel>(widgetId);
  const data = useSelector(widgetSelect.get);
  const race: CasinoRace = get(data, path);

  const launchRaceInfo = useCallback(() => {
    modal.replace([{ path: '/casino/race-info', locationState: { widgetId, path } }]);
  }, [modal, widgetId, path]);

  return (
    <div className={styles.container}>
      <div className={styles.closeContainer}>
        <CloseButton variant={Variant.Float} />
      </div>
      <div className={styles.gamesContainer}>
        <Header className={styles.header}>
          <BackButton variant="pointer" onClick={launchRaceInfo} />
          <Translation {...TXTACL_Pick_Your_Game} />
        </Header>
        <CasinoGameList
          games={race.multiGameList || []}
          className={styles.gameList}
          icon={CasinoIcon.icnSquare}
          race={{ ...race, multiGameList: [] }}
          dynamicColumnFit
          onLaunch={() => modal.close()}
        />
      </div>
    </div>
  );
};

export default CasinoRaceGameSelector;
